import React, { useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import books from "../data/books.json";
import LessonLayout from "../components/BooksReader/LessonLayout";
import LessonSidebar from "../components/BooksReader/LessonSidebar";
import LessonContent from "../components/BooksReader/LessonContent";
import LessonQuiz from "../components/BooksReader/LessonQuiz";
import NextPrevBar from "../components/BooksReader/NextPrevBar";

function flattenLessons(book) {
  const flat = [];
  book.sections.forEach(sec => {
    (sec.entries || []).forEach(e => {
      const entry = typeof e === "string" ? { slug: e, label: e, type: "text", content: "" } : e;
      flat.push({ sectionTitle: sec.title, ...entry });
    });
  });
  return flat;
}

export default function LessonView() {
  const { slug, lessonSlug } = useParams();
  const book = useMemo(() => books.find(b => b.slug === slug), [slug]);

  if (!book) return <div style={{padding:20}}>Libro no encontrado. <Link to="/libros">Volver</Link></div>;

  const flat = flattenLessons(book);
  const idx = flat.findIndex(l => l.slug === lessonSlug);
  const lesson = flat[idx] || flat[0];

  const prev = idx > 0 ? flat[idx-1] : null;
  const next = idx < flat.length-1 ? flat[idx+1] : null;

  const prevPath = prev ? `/libro/${slug}/leccion/${prev.slug}` : null;
  const nextPath = next ? `/libro/${slug}/leccion/${next.slug}` : null;

  return (
    <LessonLayout
      sidebar={<LessonSidebar book={book} />}
    >
      <LessonContent book={book} sectionTitle={lesson.sectionTitle} lesson={lesson} />
      <LessonQuiz quiz={lesson.quiz} />
      <NextPrevBar
        backToCourse={`/libro/${slug}`}
        prevPath={prevPath}
        nextPath={nextPath}
      />
    </LessonLayout>
  );
}
